import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import {
	Conversion,
	ConversionQueryParams,
	DataUpdateConversion,
} from "../types";

interface ConversionState {
	conversions: Array<Conversion>;
	conversionsTotal: number;
	conversionTotal: number;
	conversion?: Conversion;
}

const initialState: ConversionState = {
	conversions: [],
	conversionsTotal: 0,
	conversionTotal: 0,
};

export const conversionSlice = createSlice({
	name: "conversion",
	initialState,
	reducers: {
		setConversions: (state, action) => {
			state.conversions = action.payload.data;
			state.conversionsTotal = action.payload.total;
		},
		setConversion: (state, action) => {
			state.conversion = action.payload.data;
		},
	},
});

export const selectConversions = (state: RootState) =>
	state.conversion.conversions;
export const selectConversionsTotal = (state: RootState) =>
	state.conversion.conversionsTotal;
export const selectConversion = (state: RootState) =>
	state.conversion.conversion;

export const { setConversion, setConversions } = conversionSlice.actions;

export interface GetConversionsAsyncPayload {
	query: ConversionQueryParams;
	callback?: () => void;
}
export interface GetConversionDetailsPayload {
	id: string;
	callback?: (conversion?: Conversion) => void;
}

export interface UpdateConversionPayload {
	id: string;
	data: DataUpdateConversion;
	callback?: () => void;
	onError?: () => void;
}

export interface UpdateConversionStatusPayload {
	id: string;
	status: string;
	callback?: () => void;
}

export interface GetConversionsPayload {
	query: ConversionQueryParams;
	callback?: () => void;
}

export const getConversionsAsync = createAction(
	"conversion/getConversions",
	(payload: GetConversionsAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getConversionDetailsAsync = createAction(
	"conversion/getConversionDetails",
	(payload: GetConversionDetailsPayload) => ({
		payload: payload,
	}),
);


export const updateConversionAsync = createAction(
	"conversion/updateConversion",
	(payload: UpdateConversionPayload) => ({
		payload: payload,
	}),
);

export default conversionSlice.reducer;
